import { useCallback, useEffect, useRef, useState } from 'react'
import { getAcompanhamentoItensSeparados } from '../../../../../services/api/https/picking/picking.http'
import { errorHandler } from '../../../../../services/util/error.service'

const REFRESH_INTERVAL = 10000 // 10 seconds

export default function useAcompanhamentoItensSeparados(pickingId, visible) {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const intervalRef = useRef(null)
  const previousItemsRef = useRef([])
  const animationsRef = useRef({}) // { productId: 'entering' | 'moving' }

  const fetchData = useCallback(async () => {
    if (!pickingId) return
    try {
      setLoading(true)
      const data = await getAcompanhamentoItensSeparados(pickingId)

      // Detect animations
      const prevIds = previousItemsRef.current.map(i => i.product_id)
      const newAnimations = {}

      data.forEach((item, index) => {
        const prevIndex = prevIds.indexOf(item.product_id)
        if (prevIndex === -1) {
          // New item appearing
          newAnimations[item.product_id] = 'entering'
        } else if (prevIndex !== index && index < prevIndex) {
          // Item moved up
          newAnimations[item.product_id] = 'moving'
        }
      })

      animationsRef.current = newAnimations
      previousItemsRef.current = data
      setItems(data)
      setError(null)

      // Clear animations after duration
      setTimeout(() => {
        animationsRef.current = {}
      }, 600)
    } catch (e) {
      setError(errorHandler(e))
    } finally {
      setLoading(false)
    }
  }, [pickingId])

  // Start/stop auto-refresh based on visibility
  useEffect(() => {
    if (visible) {
      fetchData()
      intervalRef.current = setInterval(fetchData, REFRESH_INTERVAL)
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
      // Reset state when closing
      previousItemsRef.current = []
      animationsRef.current = {}
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [visible, fetchData])

  const manualRefresh = useCallback(() => {
    fetchData()
  }, [fetchData])

  const getAnimationClass = useCallback((productId) => {
    const anim = animationsRef.current[productId]
    if (anim === 'entering') return 'acomp-itens__card--entering'
    if (anim === 'moving') return 'acomp-itens__card--moving'
    return ''
  }, [])

  return { items, loading, error, manualRefresh, getAnimationClass }
}
